<a
  (keydown.space)="datePickerId.open()"
  (keydown.enter)="datePickerId.open()"
  (click)="datePickerId.open();"
  (focusin)="datePickerId.open();"
   [ngClass]="{
   'editable': true,
   'inlineEdit': true,
   'datePickerLink': true,
   'notAllowed': disabledFlag
   }"
  aria-label='click to edit'
  tabindex="0"
  >
  @if (isValueDate) {
    <span>{{ data?(data | date:'longDate') : defaultPlaceHolder }}</span>
  }
  @if (!isValueDate) {
    <span>{{data}}</span>
  }
</a>

<mat-form-field
  class="hide-underline" >
  <input
    matInput
    id="inlineField"
    appAutofocus
    [(ngModel)]='dataDate'
    (dateChange)="onFocusOut()"
    [matDatepicker]="datePickerId"
    style="width:0px;visibility:hidden;height:0px;"
    >
    <mat-datepicker #datePickerId (closed)="onClose()"></mat-datepicker>
  </mat-form-field>

